<template>
  <div class="forbidden-wrapper">
    <div class="card">
      <!-- KYB Not Approved Message -->
      <template v-if="isKybNotApproved">
        <div class="icon-wrapper kyb-pending">
          <img src="/assets/icons/ic_forbidden.svg" alt="KYB Pending" width="48" height="48" />
        </div>
        <h1 class="title">KYB Verification Required</h1>
        <p class="subtitle">
          The transfer feature is not yet accessible because your KYB verification has not been approved. 
          Please wait for the verification process or contact support if you have any questions.
        </p>
      </template>

      <!-- Default Forbidden Message -->
      <template v-else>
        <h1 class="title">Access denied</h1>
        <p class="subtitle">
          You don't have permission to view this page.
        </p>
      </template>

      <div class="actions">
        <button class="btn btn-primary" @click="goHome">Go to Home</button>
        <button class="btn btn-outline" @click="goBack">Go back</button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useRouter, useRoute } from "vue-router";

const router = useRouter();
const route = useRoute();

// Check if the reason is KYB not approved
const isKybNotApproved = computed(() => {
  return route.query.reason === 'kyb_not_approved';
});

function goHome() {
  router.push({ name: "DashboardApp" });
}

function goBack() {
  // If no history, fallback to home
  if (window.history.length <= 1) return goHome();
  router.back();
}
</script>

<style scoped>
.forbidden-wrapper {
  min-height: calc(100vh - 56px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: #f8f9fa;
}

.card {
  width: 100%;
  max-width: 520px;
  background: #fff;
  border: 1px solid #e9ecef;
  border-radius: 16px;
  padding: 28px;
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.06);
  text-align: center;
}

.status {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 44px;
  padding: 0 14px;
  border-radius: 999px;
  font-size: 16px;
  font-weight: 800;
  letter-spacing: 0.08em;
  color: #dc3545;
  background: rgba(220, 53, 69, 0.08);
  margin-bottom: 12px;
}

.title {
  margin: 0 0 8px;
  font-size: 22px;
  font-weight: 700;
  color: #111827;
}

.subtitle {
  margin: 0 0 18px;
  color: #6c757d;
  font-size: 14px;
  line-height: 1.6;
}

.hint {
  margin: 0 0 18px;
  color: #495057;
  font-size: 13px;
  line-height: 1.6;
}

.mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas,
    "Liberation Mono", "Courier New", monospace;
  font-size: 12px;
  padding: 2px 6px;
  border-radius: 8px;
  background: #f1f3f5;
  border: 1px solid #e9ecef;
  word-break: break-word;
}

.actions {
  display: flex;
  gap: 10px;
  justify-content: center;
}

.btn {
  border: none;
  border-radius: 999px;
  padding: 10px 16px;
  font-weight: 600;
  cursor: pointer;
}

.btn-primary {
  background: #43bb75;
  color: #fff;
}

.btn-outline {
  background: transparent;
  color: #111827;
  border: 1px solid #dee2e6;
}

.icon-wrapper {
  display: flex;
  justify-content: center;
  margin-bottom: 16px;
}

.icon-wrapper.kyb-pending {
  background: #fef3c7;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  align-items: center;
  margin: 0 auto 16px auto;
}
</style>


